// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.svg-map {\n    width: 100%;\n    height: auto;\n    stroke: #fff;\n    stroke-width: 1;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    fill: #002c5e;\n}\n.svg-map.location:hover,\n:focus {\n    fill: #53c7da;\n    outline: 0;\n}\n.tooltip {\n    position: fixed;\n    width: 200px;\n    padding: 10px;\n    border: 1px solid darkgray;\n    background-color: white;\n    border-radius: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
